module.exports = __webpack_public_path__ + "img/logo-header02.42e2cd00.png";